import { render } from "./SenaraiPemungut.vue?vue&type=template&id=1e7b41d9"
import script from "./SenaraiPemungut.vue?vue&type=script&lang=js"
export * from "./SenaraiPemungut.vue?vue&type=script&lang=js"

import "./SenaraiPemungut.vue?vue&type=style&index=0&id=1e7b41d9&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__